import styled from '@emotion/styled';

/**
 * Текст на кнопке.
 */
export const Text = styled.span``;
